import { z } from 'zod';
import { isValidIndianMobileE164, normalizeIndianPhone } from './phone';

/** UUID v4 string */
export const TenantIdSchema = z.string().uuid();

/** Any UUID */
export const UuidSchema = z.string().uuid();

/** Amount in paise (integer, non-negative) */
export const PaiseAmountSchema = z
  .number()
  .int('Amount must be an integer (paise)')
  .nonnegative('Amount cannot be negative');

/** Indian mobile number: +91 followed by 10 digits starting with 6-9 */
export const IndianPhoneSchema = z
  .string()
  .transform((value) => normalizeIndianPhone(value))
  .refine(isValidIndianMobileE164, 'Must be a valid Indian mobile: +91XXXXXXXXXX');

/** ISO date string (YYYY-MM-DD) */
export const DateStringSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be ISO date: YYYY-MM-DD');

/** ISO datetime string */
export const DateTimeSchema = z.string().datetime();

export const PaginationSchema = z.object({
  page: z.number().int().min(1).default(1),
  limit: z.number().int().min(1).max(100).default(20),
});

export type PaginationInput = z.infer<typeof PaginationSchema>;

export interface PaginatedResponse<T> {
  items: T[];
  total: number;
  page: number;
  limit: number;
  hasMore: boolean;
}
